import React from 'react';

import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';
import NextLink from 'src/components/atoms/link';

import { ROUTES } from '@helpers/constants';
import { useAppData } from '@helpers/use';

const AboutCompany = () => {
  const { t } = useTranslation('common');
  const theme = useTheme();
  const { appData } = useAppData();
  const teachWithUsUrl = appData?.footer?.teachWithUsUrl;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', width: { lg: 'unset', md: '40%', sx: 'unset' } }}>
      <Typography variant="h5" color={theme.palette.primaryV2.main}>
        {t('home.footer.company_us')}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant="body2lanna" href="/about" color={theme.palette.primaryV2.main} component={NextLink}>
          {t('home.footer.about_us')}
        </Typography>
        <Typography
          variant="body2lanna"
          target="_blank"
          href={teachWithUsUrl || ''}
          color={theme.palette.primaryV2.main}
          component={NextLink}
        >
          {t('home.footer.teach_us')}
        </Typography>
        <Typography
          variant="body2lanna"
          href={ROUTES.VIDEO_PRODUCTION_SERVICE}
          color={theme.palette.primaryV2.main}
          component={NextLink}
        >
          {t('home.footer.video_production_service')}
        </Typography>
        <Typography variant="body2lanna" href="/career" color={theme.palette.primaryV2.main} component={NextLink}>
          {t('home.footer.career')}
        </Typography>
        <Typography
          variant="body2lanna"
          href="https://investor.skilllane.com/th/home"
          color={theme.palette.primaryV2.main}
          target="_blank"
          component={NextLink}
        >
          {t('home.footer.investor_relation_link_text')}
        </Typography>
        <Typography
          variant="body2lanna"
          href="https://www.skilllane.site/"
          color={theme.palette.primaryV2.main}
          target="_blank"
          component={NextLink}
        >
          {t('home.footer.lms_plus_link_text')}
        </Typography>
      </Box>
    </Box>
  );
};

export default AboutCompany;
